import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getInvoiceDataMonthly} from '../../../apis/leader/getInvoiceDataMonthly'

const useQueryAnnounceListMonthly = () => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.announce.getAnnounceListMonthly(),
        staleTime: 180 * 1000,
        queryFn: async () => {
            const {data, pageInfo} = await getInvoiceDataMonthly()
            return {data, pageInfo}
        },
    })
    return {data, refetch}
}

export default useQueryAnnounceListMonthly
